import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../config";

export default function Login() {
  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const navigate = useNavigate();

  // ✅ If already logged in → go dashboard
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      navigate("/dhanlaxmiMyAdmin/dashboard");
    }
  }, [navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try { 
      const res = await fetch(`${BASE_URL}/api/login.php`,{
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Login Successful ✅");

        // ✅ Save login status
        localStorage.setItem("isLoggedIn", "true");

        // ✅ Save user data
        localStorage.setItem("user", JSON.stringify(data.user));

        // 🔁 Redirect (replace prevents back to login)
        navigate("/dhanlaxmiMyAdmin/dashboard", { replace: true });

      } else {
        alert(data.message);
      }

    } catch (err) {
      console.error(err);
      alert("Server error ❌");
    }
  };

 
  return (
    <div className="login-page">
      <div className="login-box">

        <h2><i className="bi bi-shield-lock"></i> Admin Login</h2>

        <form onSubmit={handleSubmit}>

          {/* EMAIL */}
          <div className="input-group">
            <i className="bi bi-envelope">   </i><p className="log">Email</p>
            <input
              type="email"
              name="email"
              placeholder="Enter email"
              onChange={handleChange}
              required
            />
          </div>

          {/* PASSWORD */}
          <div className="input-group">
            <i className="bi bi-lock">  </i><p className="log">Password</p>
            <input
              type="password"
              name="password"
              placeholder="Enter password"
              onChange={handleChange}
              required
            />
          </div>

          <p style={{ marginTop: "10px" }}>
            <a href="/dhanlaxmiMyAdmin/forgot-password">Forgot Password?</a>
          </p>

          <button type="submit" className="login-btn">
            <i className="bi bi-box-arrow-in-right"></i> Login
          </button>

        </form>

        {/* DIVIDER */}
        {/* <div className="divider">
          <span>OR</span>
        </div>

        {/* GOOGLE LOGIN */}
        {/* <button className="google-btn" onClick={handleGoogleLogin}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/300/300221.png"
            alt="google"
          />
          Continue with Google
        </button> */}

      </div>
    </div>
  );
}